module.exports = __webpack_public_path__ + "static/media/accordion-down.f4cf5391.svg";